export const taskStates = {
  0: 'To Do',
  1: 'In Progress',
  2: 'Done',
  3: 'Stuck',
};

export const workflowTaskEntityType = {
  0: 'Free',
  1: 'Style',
  2: 'Item',
  3: 'Certificate',
};

export const taskPriority = {
  1: 'Low',
  2: 'Medium',
  3: 'High',
};

export const assignedTo = {
  '-1': 'All',
  0: 'None',
  1: 'CompanyPerson',
  2: 'Brand Contact',
  3: 'Supplier Contact',
  4: 'SupplierCompanyPerson',
};
